import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`

export const IconContainer = styled.div<{ $color: string }>`
  color: ${({ $color }) => $color};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${Media.Phone`
    flex-direction: row;
    gap: 4px;
  `}
`

export const Text = styled.div<{ $color: string }>`
  color: ${({ $color }) => $color};
  ${Typography.Body}
  ${FontWeights.Regular}
`

export const Title = styled.h5`
  color: ${Colors.Neutral50};
  ${Typography.Caption}
  ${FontWeights.Regular}

  ${Media.Phone`
    color: ${Colors.Neutral100};
      ${Typography.Body};
  ${FontWeights.Medium};
  `}
`
